import styled from '@emotion/styled'
import { Colors, Shapes } from 'src/components/theme'
import { Typography } from '@mui/material'
import LogoSVG from 'src/assets/images/icon.svg'

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`

const Logo = styled.img<{ size: number }>`
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  margin-right: ${Shapes.spacing[2]}px;
`
type AlphamapLogoProps = {
  logoSize?: number
  hideText?: boolean
  textColor?: string
}

export const AlphamapLogo = (props: AlphamapLogoProps) => {
  const { logoSize = 34, hideText, textColor = Colors.textWhite } = props
  return (
    <Wrapper>
      <Logo src={LogoSVG} size={logoSize} />
      {!hideText && (
        <Typography variant="title2" color={textColor} fontSize={14}>
          AlphaMap
        </Typography>
      )}
    </Wrapper>
  )
}
